import React from 'react'
import { Card, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Logo from '../components/Logo';
import { useAuth } from '../contexts/auth';

export default function Home() {
  const { t } = useTranslation();
  const { loggedUser } = useAuth();

  return (
    <Container>
      <Card className="mb-5">
        <Card.Body>
          <div className="d-flex justify-content-center align-items-center py-3">
            <Logo size={100} />
          </div>
          <h3>{t('home.welcome', { user: loggedUser ? loggedUser.firstname + " " + loggedUser.lastname : "" })}</h3>
        </Card.Body>
      </Card>
    </Container>
  )
}